import { CountryCodeList } from 'types/countries';
import { SiteLanguage, SiteNameSpace } from 'constants/locale';
import ExprealtyUsTheme from 'themes/exprealtyUS';
import { JoinPageContactPaths } from 'constants/urls';
import { GTM_CLICK_SIGN_ME_UP_BUTTON_JOIN_EXP, GTM_CLICK_BUILT_FOR_THIS_JOIN_US_BUTTON_JOIN_EXP, GTM_CLICK_LEARN_MORE_BUTTON_JOIN_EXP, GTM_CLICK_GET_NOW_BUTTON_JOIN_EXP } from 'constants/events';
import React from 'react';
import { ThemeNames } from 'types/themes';
import { JOIN_EXP_HIGHLIGHT_COLOR } from './exp-realty-ca.tenant';

import type { ThemeConfig } from 'themes/themeConfig';
import type { Tenant } from '../types';

export const EXP_REALTY_US_TENANT_ID = 'exprealtyUS' as const;
export const EXP_REALTY_US_L18N_NAMESPACE = EXP_REALTY_US_TENANT_ID;
export const EXP_REALTY_US_L18N_NAMESPACES = [
  EXP_REALTY_US_L18N_NAMESPACE,
  SiteNameSpace.Common,
  SiteNameSpace.FormError,
  SiteNameSpace.Modal,
] as const;

const homeConfig = {
  heroVideo: '/us-hero-1.mp4',
  joinLink: 'https://join.exprealty.com',
  joinUsSection:{
    title: 'Why Join',
    title2: 'eXp Realty?',
    description: 'When you join eXp Realty, you become part of a global family of agents and partners dedicated to transforming the real estate experience. Learn more about how we empower our agents with world-class education, strategic partnership and stock awards.',
    imageUrl: '/assets/images/exp-homepage/why-join-exp-us.png',
    buttonText: 'Learn More',
    link: '/join-exp',
  },
  internalLinks: [
    {
      title: 'Popular US Cities',
      links: [
        {
          label: 'New York',
          link: '/new-york-ny-real-estate',
        },
        {
          label: 'Los Angeles',
          link: '/los-angeles-ca-real-estate',
        },
        {
          label: 'Chicago',
          link: '/chicago-il-real-estate',
        },
        {
          label: 'Houston',
          link: '/houston-tx-real-estate',
        },
        {
          label: 'Phoenix',
          link: '/phoenix-az-real-estate',
        },
        {
          label: 'Philadelphia',
          link: '/philadelphia-pa-real-estate',
        },
        {
          label: 'San Antonio',
          link: '/san-antonio-tx-real-estate',
        },
        {
          label: 'San Diego',
          link: '/san-diego-ca-real-estate',
        },
        {
          label: 'Dallas',
          link: '/dallas-tx-real-estate',
        },
        {
          label: 'San Jose',
          link: '/san-jose-ca-real-estate',
        },
      ],
    },
    {
      title: 'Popular US States',
      links: [
        {
          label: 'Alabama',
          link: '/alabama-real-estate',
        },
        {
          label: 'Alaska',
          link: '/alaska-real-estate',
        },
        {
          label: 'Arizona',
          link: '/arizona-real-estate',
        },
        {
          label: 'Arkansas',
          link: '/arkansas-real-estate',
        },
        {
          label: 'California',
          link: '/california-real-estate',
        },
        {
          label: 'Colorado',
          link: '/colorado-real-estate',
        },
        {
          label: 'Connecticut',
          link: '/connecticut-real-estate',
        },
        {
          label: 'Delaware',
          link: '/delaware-real-estate',
        },
        {
          label: 'Florida',
          link: '/florida-real-estate',
        },
        {
          label: 'Georgia',
          link: '/georgia-real-estate',
        },
        {
          label: 'Hawaii',
          link: '/hawaii-real-estate',
        },
        {
          label: 'Idaho',
          link: '/idaho-real-estate',
        },
        {
          label: 'Illinois',
          link: '/illinois-real-estate',
        },
        {
          label: 'Indiana',
          link: '/indiana-real-estate',
        },
        {
          label: 'Iowa',
          link: '/iowa-real-estate',
        },
        {
          label: 'Kansas',
          link: '/kansas-real-estate',
        },
        {
          label: 'Kentucky',
          link: '/kentucky-real-estate',
        },
        {
          label: 'Louisiana',
          link: '/louisiana-real-estate',
        },
        {
          label: 'Maine',
          link: '/maine-real-estate',
        },
        {
          label: 'Maryland',
          link: '/maryland-real-estate',
        },
        {
          label: 'Massachusetts',
          link: '/massachusetts-real-estate',
        },
        {
          label: 'Michigan',
          link: '/michigan-real-estate',
        },
        {
          label: 'Minnesota',
          link: '/minnesota-real-estate',
        },
        {
          label: 'Mississippi',
          link: '/mississippi-real-estate',
        },
        {
          label: 'Missouri',
          link: '/missouri-real-estate',
        },
        {
          label: 'Montana',
          link: '/montana-real-estate',
        },
        {
          label: 'Nebraska',
          link: '/nebraska-real-estate',
        },
        {
          label: 'Nevada',
          link: '/nevada-real-estate',
        },
        {
          label: 'New Hampshire',
          link: '/new-hampshire-real-estate',
        },
        {
          label: 'New Jersey',
          link: '/new-jersey-real-estate',
        },
        {
          label: 'New Mexico',
          link: '/new-mexico-real-estate',
        },
        {
          label: 'New York',
          link: '/new-york-real-estate',
        },
        {
          label: 'North Carolina',
          link: '/north-carolina-real-estate',
        },
        {
          label: 'North Dakota',
          link: '/north-dakota-real-estate',
        },
        {
          label: 'Ohio',
          link: '/ohio-real-estate',
        },
        {
          label: 'Oklahoma',
          link: '/oklahoma-real-estate',
        },
        {
          label: 'Oregon',
          link: '/oregon-real-estate',
        },
        {
          label: 'Pennsylvania',
          link: '/pennsylvania-real-estate',
        },
        {
          label: 'Rhode Island',
          link: '/rhode-island-real-estate',
        },
        {
          label: 'South Carolina',
          link: '/south-carolina-real-estate',
        },
        {
          label: 'South Dakota',
          link: '/south-dakota-real-estate',
        },
        {
          label: 'Tennessee',
          link: '/tennessee-real-estate',
        },
        {
          label: 'Texas',
          link: '/texas-real-estate',
        },
        {
          label: 'Utah',
          link: '/utah-real-estate',
        },
        {
          label: 'Vermont',
          link: '/vermont-real-estate',
        },
        {
          label: 'Virginia',
          link: '/virginia-real-estate',
        },
        {
          label: 'Washington',
          link: '/washington-real-estate',
        },
        {
          label: 'West Virginia',
          link: '/west-virginia-real-estate',
        },
        {
          label: 'Wisconsin',
          link: '/wisconsin-real-estate',
        },
        {
          label: 'Wyoming',
          link: '/wyoming-real-estate',
        },
      ],
    },
  ],
  contentCards: {
    sectionTitleParts: ['With eXp, Possibility', 'Becomes', 'Reality'],
    cards: [
      {
        title: 'Buy With Us',
        image: '/next/assets/images/content-cards/us-buy.jpg',
        titleColor: 'rgba(255, 255, 255, 0.7)',
        backgroundColor: '#163259',
        content: 'Buying a home is one of the most important decisions you will make, and our local experts at eXp Realty are here to make the process as easy as possible.',
        link: '/search?openSearch=true',
        desktopTransform: 'rotate(-5deg)',
        tabletTransform: 'none',
        rounded: true,
        altText: 'A man with his hair in a bun hugging a woman outside of a modern building.',
      },
      {
        title: 'Sell With Us',
        image: '/next/assets/images/content-cards/us-sell.jpg',
        titleColor: 'rgba(255, 255, 255, 0.7)',
        backgroundColor: '#6C82A0',
        content: 'Selling your home can feel like a big project, but our agents are ready to make every step of the journey as smooth as possible. Let an eXp agent be your guide to selling your home like a pro.',
        link: '/sell',
        tabletTransform: 'translateY(3em)',
        translateYTablet: '50',
        altText: 'A smiling family, with two kids playing inside a cardboard box',
      },
      {
        title: 'Find an Agent',
        image: '/next/assets/images/content-cards/us-agent.jpg',
        titleColor: '#163259',
        backgroundColor: '#DAE0E7',
        content: 'Whether you are looking to buy, sell or rent, our experienced and passionate agents are on hand to help make it happen. Find the perfect agent for your needs today!',
        link: '/agents-search',
        desktopTransform: 'rotate(2deg) translateY(-1.5em)',
        tabletTransform: 'none',
        translateYDesktop: '-20',
        altText: 'A group of professionals sitting around a table, engaged in conversation.',
      },
      {
        title: 'Cash Offers',
        image: '/next/assets/images/content-cards/us-cash.jpg',
        titleColor: '#6D6F7C',
        backgroundColor: '#EEEEEE',
        content: 'Discover how you can get cash offers quickly on your home without staging or listing. Our Express Offers platform easily connects individual home owners with investors, avoiding some of the stress of a traditional sale. Move on your own timeline.',
        link: 'https://expressoffers.com/',
        desktopTransform: 'rotate(7deg) translateY(2em)',
        tabletTransform: 'translateY(3em)',
        translateYDesktop: '40',
        translateYTablet: '50',
        rounded: true,
        altText: 'Close-up of hands typing on a laptop.',
      },
    ],
  },
};

const joinExpUSNamespace = `join.${EXP_REALTY_US_L18N_NAMESPACE}`;

export const joinExpUSConfig = {
  namespace: joinExpUSNamespace,
  joinFormLink: JoinPageContactPaths[ThemeNames.EXP_REALTY_US],
  learnMoreClickEvent: GTM_CLICK_LEARN_MORE_BUTTON_JOIN_EXP,
  builtForThisJoinUsClickEvent: GTM_CLICK_BUILT_FOR_THIS_JOIN_US_BUTTON_JOIN_EXP,
  signMeUpClickEvent: GTM_CLICK_SIGN_ME_UP_BUTTON_JOIN_EXP,
  getNowClickEvent: GTM_CLICK_GET_NOW_BUTTON_JOIN_EXP,
  glennQuoteConfig: {
    authorImage: '/next/assets/images/join-expus/Glenn.jpg',
    authorImageAlt: 'Glenn Sanford',
    authorTitle: `${joinExpUSNamespace}:glennQuote.authorTitle`,
    authorName: 'Glenn Sanford',
    quoteContent: `${joinExpUSNamespace}:glennQuote.quoteContent`,
    ctaText: `${joinExpUSNamespace}:glennQuote.ctaText`,
    theme: {
      color: JOIN_EXP_HIGHLIGHT_COLOR,
    },
  },
  leoQuoteConfig: {
    authorImage: '/next/assets/images/join-expus/Leo.jpg',
    authorImageAlt: 'Leo Pareja',
    authorTitle: `${joinExpUSNamespace}:leoQuote.authorTitle`,
    authorName: 'Leo Pareja',
    quoteContent: `${joinExpUSNamespace}:leoQuote.quoteContent`,
    theme: {
      color: JOIN_EXP_HIGHLIGHT_COLOR,
    },
  },
  videoCardData: [
    {
      videoId: 'hv5oA6q_phM',
      bottomText: `${joinExpUSNamespace}:videoCards.card1`,
    },
    {
      videoId: 'AA76L8hw7oU',
      bottomText: `${joinExpUSNamespace}:videoCards.card2`,
    },
    {
      videoId: 'pGH14z9XpRc',
      bottomText: `${joinExpUSNamespace}:videoCards.card3`,
    },
    {
      videoId: 'vK24zkG4C0k',
      bottomText: `${joinExpUSNamespace}:videoCards.card4`,
    },
    {
      videoId: 'VdulH47weDY',
      bottomText: `${joinExpUSNamespace}:videoCards.card5`,
    },
    {
      videoId: 'H_DP7Pmme0s',
      bottomText: `${joinExpUSNamespace}:videoCards.card6`,
    },
    {
      videoId: 'xcx9cySzqFY',
      bottomText: `${joinExpUSNamespace}:videoCards.card7`,
    },
    {
      videoId: 'x0dZCrsGBAw',
      bottomText: `${joinExpUSNamespace}:videoCards.card8`,
    },
  ],
  cardStackData: [
    {
      title: `${joinExpUSNamespace}:cardStack.freedom.title`,
      description: `${joinExpUSNamespace}:cardStack.freedom.description`,
      imageSrc: '/next/assets/images/join-expus/card-stack-image-1.png',
      backgroundColor: '#0C0F24',
      textColor: '#fff',
      imageAlt: `${joinExpUSNamespace}:cardStack.freedom.imageAlt`,
    },
    {
      title: `${joinExpUSNamespace}:cardStack.ownership.title`,
      description: `${joinExpUSNamespace}:cardStack.ownership.description`,
      imageSrc: '/next/assets/images/join-expus/card-stack-image-2.png',
      backgroundColor: '#6D6F7C',
      textColor: '#fff',
      imageAlt: `${joinExpUSNamespace}:cardStack.ownership.imageAlt`,
    },
    {
      title: `${joinExpUSNamespace}:cardStack.growth.title`,
      description: `${joinExpUSNamespace}:cardStack.growth.description`,
      imageSrc: '/next/assets/images/join-expus/card-stack-image-3.png',
      backgroundColor: '#DAE0E7',
      textColor: '#0C0F24',
      imageAlt: `${joinExpUSNamespace}:cardStack.growth.imageAlt`,
    },
    {
      title: `${joinExpUSNamespace}:cardStack.community.title`,
      description: `${joinExpUSNamespace}:cardStack.community.description`,
      imageSrc: '/next/assets/images/join-expus/card-stack-image-4.png',
      backgroundColor: '#EDF2F7',
      textColor: '#0C0F24',
      imageAlt: `${joinExpUSNamespace}:cardStack.community.imageAlt`,
    },
  ],
  programsData: [
    {
      image: '/next/assets/images/join-expus/program-3.jpeg',
      imageAlt: `${joinExpUSNamespace}:programs.boost.imageAlt`,
      title: `${joinExpUSNamespace}:programs.boost.title`,
      description: `${joinExpUSNamespace}:programs.boost.description`,
      buttonText: `${joinExpUSNamespace}:programs.boost.buttonText`,
      buttonLink: 'https://docs.google.com/forms/d/e/1FAIpQLScb_rXcHYN2yOY7VFAuG1UhvjTwpKRWteFsB_fZhnzsnBZTZg/viewform',
    },
    {
      image: '/next/assets/images/join-expus/program-4.jpeg',
      imageAlt: `${joinExpUSNamespace}:programs.thrive.imageAlt`,
      title: `${joinExpUSNamespace}:programs.thrive.title`,
      description: `${joinExpUSNamespace}:programs.thrive.description`,
      buttonText: `${joinExpUSNamespace}:programs.thrive.buttonText`,
      buttonLink: 'https://docs.google.com/forms/d/e/1FAIpQLSeIE4Y1gVhUACFa1DEj_qD0k-1zqWBKn8s6X3a1fCDpvXJodQ/viewform',
    },
  ],
  faq: {
    title: `${joinExpUSNamespace}:faq.title`,
    content:[
      {
        title: `${joinExpUSNamespace}:faq.q1.title`,
        children: `${joinExpUSNamespace}:faq.q1.children`,
      },
      {
        title: `${joinExpUSNamespace}:faq.q2.title`,
        children: `${joinExpUSNamespace}:faq.q2.children`,
      },
      {
        title: `${joinExpUSNamespace}:faq.q3.title`,
        children: `${joinExpUSNamespace}:faq.q3.children`,
        styleOverrides: {
          p: {
            fontWeight: 'bold',
            marginBottom: '0.5rem',
            marginTop: '0.5rem',
          },
        },
      },
      {
        title: `${joinExpUSNamespace}:faq.q4.title`,
        children: `${joinExpUSNamespace}:faq.q4.children`,
      },
      {
        title: `${joinExpUSNamespace}:faq.q5.title`,
        children: `${joinExpUSNamespace}:faq.q5.children`,
      },
      {
        title: `${joinExpUSNamespace}:faq.q6.title`,
        children: `${joinExpUSNamespace}:faq.q6.children`,
      },
      {
        title: `${joinExpUSNamespace}:faq.q7.title`,
        children: `${joinExpUSNamespace}:faq.q7.children`,
        values: { contactLink: JoinPageContactPaths[ThemeNames.EXP_REALTY_US] },
      },
    ],
  },
};

export const expRealtyUSTenant: Tenant<ThemeConfig> = {
  id: EXP_REALTY_US_TENANT_ID,
  hosts: ['exprealty.com', 'www.exprealty.com'],
  theme: ExprealtyUsTheme,
  localization: {
    languages: [SiteLanguage.English, SiteLanguage.Spanish],
    countries: [CountryCodeList.UNITED_STATES],
    namespaces: EXP_REALTY_US_L18N_NAMESPACES,
    defaultLanguage: SiteLanguage.English,
  },
  config: {
    home: homeConfig,
    joinExp: joinExpUSConfig,
    filters: {
      hideExpiredListings: true, // US feeds don't have expired listings so remove the corresponding filter option
    },
  },
  debug: {
    forceTenantHeaderValue: 'useTenant="useExpRealtyUS"',
  },
  features: {
    MyLinkMyLead: true,
    AgentSearch: true,
  },
};